/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import '@webteam/colors/lib/index.css';
import '@rescui/colors/lib/index.css';

import FocusManager from '@rescui/focus-manager';

export const onInitialClientRender = () => {
  new FocusManager();
};
